import { SvgIcon, SvgIconTypeMap } from '@material-ui/core'
import { OverridableComponent } from '@material-ui/core/OverridableComponent'
import clsx from 'clsx'
import React from 'react'

const InsertTextFieldIcon: OverridableComponent<SvgIconTypeMap<{}, 'svg'>> = (
    props: any
) => (
    <SvgIcon
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        className={clsx('InsertTextFieldIcon', props.className)}
    >
        <path
            d="M14.7885 0.167969L16 4.71105L14.9974 4.98259C14.5274 4.07397 14.047 3.16536 13.4935 2.70583C12.9399 2.25674 12.2924 2.25674 11.6554 2.25674H9.04439V13.2228C9.04439 13.745 9.04439 14.2672 9.38903 14.5283C9.74412 14.7894 10.4334 14.7894 11.1332 14.7894V15.8338H4.86684V14.7894C5.56658 14.7894 6.25587 14.7894 6.61097 14.5283C6.95561 14.2672 6.95561 13.745 6.95561 13.2228V2.25674H4.34465C3.70757 2.25674 3.06005 2.25674 2.50653 2.70583C1.953 3.16536 1.47258 4.07397 1.00261 4.98259L0 4.71105L1.21149 0.167969H14.7885Z"
            fill="#314959"
        />
    </SvgIcon>
)

export default InsertTextFieldIcon
